/** Query-key root for the pinned band (ADR 0047). Kept distinct from
 *  `email-index` so the band (a flat `EmailMetadataRow[]`) never collides with
 *  the infinite list's paged cache shape, and so pin mutations can
 *  invalidate/patch it explicitly.
 *
 *  Lives in its own module (mirroring `email-index-key.ts`) so invalidation
 *  helpers can reference the key without importing the hook — and the data
 *  hook's dependency graph — into every mutation that retires a pin. */
export const PINNED_BAND_KEY = 'pinned-correspondences';
